import { ColumnFilterType } from "shared/cubiq-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export enum ExtendedOrderTypeIdentifier {
  OTHER,
  BENCHMARK,
  ALGO,
}

export const OBJECT_COLUMN_FILTER_TYPES: Array<ColumnFilterType> = [
  ColumnFilterType.ENUM,
  ColumnFilterType.ACCOUNT,
  ColumnFilterType.ACCOUNTID,
  ColumnFilterType.BRANCH,
  ColumnFilterType.CLIENT,
  ColumnFilterType.CLIENTID,
  ColumnFilterType.TRADERGROUP,
  ColumnFilterType.SALESGROUP,
  ColumnFilterType.CURRENCY,
  ColumnFilterType.CURRENCY_PAIR,
  ColumnFilterType.CURRENCY_PAIR_GROUP,
  ColumnFilterType.USER,
  ColumnFilterType.RATE_SOURCE,
  ColumnFilterType.ORDERSTATE,
  ColumnFilterType.ORDERTYPE,
  ColumnFilterType.DEALSTATE,
  ColumnFilterType.CHANNEL,
  ColumnFilterType.FIXCODE,
  ColumnFilterType.BM_FIXCODE,
  ColumnFilterType.DATE_TENOR,
];

export const COMPOSITE_COLUMN_FILTER_TYPES: Array<ColumnFilterType> = [
  ColumnFilterType.COMPOSITE_ENUM,
];

export const OBJECT_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.In,
  CubiqTS.Operator.NotIn,
];

export const NUMBER_COLUMN_FILTER_TYPES: Array<ColumnFilterType> = [
  ColumnFilterType.DATE,
  ColumnFilterType.DATETIME,
  ColumnFilterType.NUMBER,
  ColumnFilterType.INT,
  ColumnFilterType.PERCENTAGE,
];

export const NUMBER_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.Equal,
  CubiqTS.Operator.NotEqual,
  CubiqTS.Operator.Less,
  CubiqTS.Operator.LessOrEqual,
  CubiqTS.Operator.Greater,
  CubiqTS.Operator.GreaterOrEqual,
  CubiqTS.Operator.Between,
  CubiqTS.Operator.NotBetween,
];

export const DATE_COLUMN_FILTER_TYPES: Array<ColumnFilterType> = [
  ColumnFilterType.DATE,
  ColumnFilterType.DATETIME,
  ColumnFilterType.TIME,
];

export const DATE_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.Equal,
  CubiqTS.Operator.NotEqual,
  CubiqTS.Operator.Less,
  CubiqTS.Operator.Greater,
  CubiqTS.Operator.Between,
  CubiqTS.Operator.NotBetween,
];

export const VALUE_DATE_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.Equal,
  CubiqTS.Operator.NotEqual,
  CubiqTS.Operator.Less,
  CubiqTS.Operator.LessOrEqual,
  CubiqTS.Operator.Greater,
  CubiqTS.Operator.GreaterOrEqual,
  CubiqTS.Operator.Between,
];

export const BOOLEAN_COLUMN_FILTER_TYPES: Array<ColumnFilterType> = [
  ColumnFilterType.BOOLEAN,
  ColumnFilterType.AUTO_ELIGIBLE,
];

export const BOOLEAN_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.Equal,
  CubiqTS.Operator.NotEqual,
];

export const TEMPERATURE_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.GreaterOrEqual,
];

export const STRING_COLUMN_FILTER_TYPES: Array<ColumnFilterType> = [ColumnFilterType.STRING];

export const STRING_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.Equal,
  CubiqTS.Operator.NotEqual,
  CubiqTS.Operator.Contains,
  CubiqTS.Operator.DoesNotContain,
];

export const COMMENTS_STRING_COLUMN_FILTER_OPS: Array<CubiqTS.Operator> = [
  CubiqTS.Operator.Contains,
  CubiqTS.Operator.DoesNotContain,
];

export const OBJECT_CURRENCY_PAIR_GROUP_COLUMN_FILTER_TYPE: ColumnFilterType =
  ColumnFilterType.CURRENCY_PAIR;

export const OR_CONDITION_LIMIT: number = 5;

export const FILTER_SELECTOR_MODES: Array<any> = [
  { label: "My Filters", value: "myFilters" },
  { label: "All Filters", value: "allFilters" },
];

export const OBJECT_SORT: any = (a, b) => {
  return a.label.toLowerCase() < b.label.toLowerCase()
    ? -1
    : a.label.toLowerCase() > b.label.toLowerCase()
    ? 1
    : 0;
};

export const ACCOUNT_FILTER_TYPES: Array<ColumnFilterType> = [
  ColumnFilterType.ACCOUNT,
  ColumnFilterType.ACCOUNTID,
];
export const CLIENT_FILTER_TYPES: Array<ColumnFilterType> = [
  ColumnFilterType.CLIENT,
  ColumnFilterType.CLIENTID,
];

export const BFXBLOTTERFILTERCONDITIONLABELS: {
  label: string;
  value: CubiqTS.Operator;
}[] = [
  { label: "in", value: CubiqTS.Operator.In },
  { label: "not in", value: CubiqTS.Operator.NotIn },
  { label: "=", value: CubiqTS.Operator.Equal },
  { label: "<>", value: CubiqTS.Operator.NotEqual },
  { label: "<", value: CubiqTS.Operator.Less },
  { label: "<=", value: CubiqTS.Operator.LessOrEqual },
  { label: ">", value: CubiqTS.Operator.Greater },
  { label: ">=", value: CubiqTS.Operator.GreaterOrEqual },
  { label: "between", value: CubiqTS.Operator.Between },
  { label: "not between", value: CubiqTS.Operator.NotBetween },
  { label: "is null", value: CubiqTS.Operator.IsNull },
  { label: "is not null", value: CubiqTS.Operator.IsNotNull },
  { label: "contains", value: CubiqTS.Operator.Contains },
  { label: "does not contain", value: CubiqTS.Operator.DoesNotContain },
];

export const BFXBLOTTERFILTERTYPES: {
  label: string;
  value: CubiqTS.BlotterType;
  extendedTypeId: ExtendedOrderTypeIdentifier;
}[] = [
  {
    label: "Order Blotter",
    value: CubiqTS.BlotterType.ORDER,
    extendedTypeId: ExtendedOrderTypeIdentifier.OTHER,
  },
  {
    label: "Intervention Blotter",
    value: CubiqTS.BlotterType.INTERVENTION,
    extendedTypeId: ExtendedOrderTypeIdentifier.OTHER,
  },
  {
    label: "Client Trade Blotter",
    value: CubiqTS.BlotterType.TRADE,
    extendedTypeId: ExtendedOrderTypeIdentifier.OTHER,
  },
  {
    label: "Benchmark Summary Blotter",
    value: CubiqTS.BlotterType.ORDER,
    extendedTypeId: ExtendedOrderTypeIdentifier.BENCHMARK,
  },
  {
    label: "Algo Monitor",
    value: CubiqTS.BlotterType.ORDER,
    extendedTypeId: ExtendedOrderTypeIdentifier.ALGO,
  },
  {
    label: "Risk Trade Blotter",
    value: CubiqTS.BlotterType.RISKTRADE,
    extendedTypeId: ExtendedOrderTypeIdentifier.OTHER,
  },
];
